module.exports = __webpack_public_path__ + "static/img/190329-feature-twins.293ed00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190329-feature-twins.jpg
// module id = rKtT
// module chunks = 0